import React, { Component, Fragment } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { fetchDataCheckBox } from "../service";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";

class StockOpnameAddData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      allChecked: false,
      dataCheckBox: [],
    };
  }

  componentDidMount = async () => {
    console.log(this.props);
    this.handleTriggerLoading();
    await fetchDataCheckBox(
      this.setState.bind(this),
      this.props.controls.stockOpnameType.value
    );

    if (
      this.props.activityType === "UPDATE" &&
      this.props.dataChecked.length > 0
    ) {
    } else if (this.props.activityType === "UPDATE") {
      this.preselectUpdateCheckbox();
    }
    this.handleTriggerLoading();
  };

  preselectUpdateCheckbox = () => {
    const { rawDetailData, onDataCheckedChange, controls } = this.props;
    const { dataCheckBox } = this.state;
    console.log(rawDetailData);

    if (!rawDetailData || dataCheckBox.length === 0) return;

    const type = controls.stockOpnameType?.value?.value;
    console.log(type);

    let savedKeys = [];

    if (type === "PART") {
      if (rawDetailData.partNonQrList) {
        savedKeys.push(
          ...rawDetailData.partNonQrList
            .map((item) => item.partCode?.partCategory?.key)
            .filter(Boolean)
        );
      }
      if (rawDetailData.partQrList) {
        savedKeys.push(
          ...rawDetailData.partQrList
            .map((item) => item.partCode?.partCategory?.key)
            .filter(Boolean)
        );
      }
    }

    if (type === "GIFT") {
      if (rawDetailData.listNonQr) {
        savedKeys.push(
          ...rawDetailData.listNonQr
            .map((item) => item.giftCode?.categoryDTO?.key)
            .filter(Boolean)
        );
      }
      if (rawDetailData.listQr) {
        savedKeys.push(
          ...rawDetailData.listQr
            .map((item) => item.giftCode?.categoryDTO?.key)
            .filter(Boolean)
        );
      }
    }

    if (type === "OTHER_ITEM") {
      const extractKeys = (list) => {
        if (!Array.isArray(list)) return [];
        return list
          .map((item) => item?.dataOtherItem?.kodeotheritem)
          .filter(Boolean);
      };

      const nonQrKeys = extractKeys(rawDetailData.dataOtherItem);
      const qrKeys = extractKeys(rawDetailData.dataOtherItemBarcode);

      savedKeys.push(...nonQrKeys, ...qrKeys);

      savedKeys = [...new Set(savedKeys)];
    }

    const matchedIds = dataCheckBox
      .filter((cb) => savedKeys.includes(cb.id))
      .map((cb) => cb.id);

    onDataCheckedChange(matchedIds);
  };

  isChecked = (id) => {
    if (!R.isNil(id)) {
      return !!this.props.dataChecked.find((item) => item === id);
    } else {
      return (
        this.state.dataCheckBox.length > 0 &&
        this.state.dataCheckBox.every((item) =>
          this.props.dataChecked.includes(item.id)
        )
      );
    }
  };

  handleCheckboxChange = (e, item) => {
    const { checked } = e.target;
    const { dataChecked } = this.props;

    if (item === "all") {
      let updatedDataChecked = checked
        ? this.state.dataCheckBox.map((item) => item.id)
        : [];
      this.props.onDataCheckedChange(updatedDataChecked);
    } else {
      let updatedDataChecked = checked
        ? [...dataChecked, item]
        : dataChecked.filter((id) => id !== item);

      this.props.onDataCheckedChange(updatedDataChecked);
    }
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  render() {
    let typeValue = this.props.controls.stockOpnameType?.value?.label == 'GIFT' ? 'Hadiah' : this.props.controls.stockOpnameType?.value?.label == 'OTHER_ITEM' ? 'Barang Lain' : this.props.controls.stockOpnameType?.value?.label
    
    return (
      <Fragment>
        <SimpleModal
          title="Tambah Data SOP"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <div className="grid grid-2x grid-mobile-none gap-20px margin-bottom-20px">
                <div id="grid-1">
                  <SimpleInput
                    id="input_text_lokasi"
                    name="lokasi"
                    label="Lokasi"
                    readOnly={true}
                    value={this.props.controls.kodeLocation?.value?.label}
                  />

                  <SimpleInput
                    id="input_text_tipe"
                    name="type"
                    label="Tipe"
                    readOnly={true}
                    value={typeValue}
                  />
                </div>
              </div>

              <FlexView wrap={true} style={{ gap: "20px", maxHeight: "auto" }}>
                <div className="grid grid-3x gap-30px">
                  <div id="grid-1">
                    <SimpleCheckBox
                      id={`all`}
                      key={`all`}
                      label={"All"}
                      checked={this.isChecked()}
                      onChange={(e) => this.handleCheckboxChange(e, "all")}
                    />
                    {this.state.dataCheckBox.length > 0 &&
                      this.state.dataCheckBox.map((item, index) => {
                        if (index % 3 === 2) {
                          return (
                            <SimpleCheckBox
                              id={`${index}-${item.id}`}
                              key={item.id}
                              styles={{ marginTop: "10px" }}
                              label={item.name}
                              checked={this.isChecked(item.id)}
                              onChange={(e) =>
                                this.handleCheckboxChange(e, item.id)
                              }
                            />
                          );
                        }
                      })}
                  </div>
                  <div id="grid-2">
                    {this.state.dataCheckBox.length > 0 &&
                      this.state.dataCheckBox.map((item, index) => {
                        if (index % 3 === 0) {
                          return (
                            <SimpleCheckBox
                              id={`${index}-${item.id}`}
                              key={item.id}
                              label={item.name}
                              checked={this.isChecked(item.id)}
                              onChange={(e) =>
                                this.handleCheckboxChange(e, item.id)
                              }
                            />
                          );
                        }
                      })}
                  </div>
                  <div id="grid-3">
                    {this.state.dataCheckBox.length > 0 &&
                      this.state.dataCheckBox.map((item, index) => {
                        if (index % 3 === 1) {
                          return (
                            <SimpleCheckBox
                              id={`${index}-${item.id}`}
                              key={item.id}
                              label={item.name}
                              checked={this.isChecked(item.id)}
                              onChange={(e) =>
                                this.handleCheckboxChange(e, item.id)
                              }
                            />
                          );
                        }
                      })}
                  </div>
                </div>
              </FlexView>

              <FlexView
                style={{ justifyContent: "end" }}
                marginTop={50}
                marginBottom={20}
              >
                <SimpleButton onClick={this.props.onSubmit} text={"Simpan"} />
              </FlexView>
            </ModalContainer>
          }
        />

        <SimpleLoadingOverlay active={this.state.loading} />
      </Fragment>
    );
  }
}

export default StockOpnameAddData;
